/**
 * PolicySlice Insurances Reducers
 * 
 * Reducers for managing effective insurances on policies.
 */

import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { PolicySliceState } from '../state';

// =============================================================================
// INSURANCES REDUCERS
// =============================================================================

/**
 * Add an insurance to the policy
 */
export const addInsurance: CaseReducer<PolicySliceState, PayloadAction<string>> = (
  state,
  action
) => {
  if (state.currentPolicy && !state.currentPolicy.effectiveInsurances.includes(action.payload)) {
    state.currentPolicy.effectiveInsurances.push(action.payload);
    state.isEdited = true;
    if (!state.editedFields.includes('effectiveInsurances')) {
      state.editedFields.push('effectiveInsurances');
    }
  }
};

/**
 * Remove an insurance from the policy
 */
export const removeInsurance: CaseReducer<PolicySliceState, PayloadAction<string>> = (
  state,
  action
) => {
  if (state.currentPolicy) {
    state.currentPolicy.effectiveInsurances = state.currentPolicy.effectiveInsurances.filter(
      (insurance) => insurance !== action.payload
    );
    state.isEdited = true;
    if (!state.editedFields.includes('effectiveInsurances')) {
      state.editedFields.push('effectiveInsurances');
    }
  }
};

/**
 * Set all insurances at once
 */
export const setInsurances: CaseReducer<PolicySliceState, PayloadAction<string[]>> = (
  state,
  action
) => {
  if (state.currentPolicy) {
    state.currentPolicy.effectiveInsurances = action.payload;
    state.isEdited = true;
    if (!state.editedFields.includes('effectiveInsurances')) {
      state.editedFields.push('effectiveInsurances');
    }
  }
};
